import { useState, useEffect, useCallback } from "react";
import moment from "moment";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Filtros from "../../components/filtros/Filtros";
// consts
import { saldos as titles } from "../../consts/titulos-de-tablas";
import { Routes } from "../../consts/Routes-App";
//Assets
import CircularIndeterminate from "../../components/utils/spinner/Spinner";
//Services
import { MWSaldoGet } from "../../services/hooli-services";
// recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  rowSelected,
  userCredentials,
  routeInfo,
} from "../../recoilState/GlobalState";
import * as XLSX from "xlsx";
import { HeaderButton } from "../../components";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

const today = new Date().toISOString().substring(0, 10);

export default function Saldos() {
  const [saldos, setSaldos] = useState([]);
  const [filtros, setFiltros] = useState({
    moneda: "ARS",
    desde: moment(today).subtract(6, "days").format("YYYY-MM-DD"),
    hasta: today,
  });
  const [cargando, setCargando] = useState(false);
  const setRow = useSetRecoilState(rowSelected);
  const setRoute = useSetRecoilState(routeInfo);
  const credentials = useRecoilValue(userCredentials);

  const handleExport = () => {
          const rowsFilter = saldos.map((e) => ({
            [titles[0]]: e[titles[0]],
            [titles[1]]: e[titles[1]],
            [titles[2]]: e[titles[2]],
            [titles[3]]: e[titles[3]],
            [titles[4]]: e[titles[4]],
            [titles[5]]: e[titles[5]],
            [titles[6]]: e[titles[6]],
          }));
          const worksheet = XLSX.utils.json_to_sheet(rowsFilter);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, `saldos_diarios_${filtros.desde}_${filtros.hasta}.xlsx`, { compression: true });
        };
        
  const retrieveSaldos = useCallback(async () => {
    setCargando(true);
    const payload = {
      ...credentials,
      merchantId: credentials.merchantId,
      fechaDesde: filtros.desde,
      fechaHasta: filtros.hasta,
      monedaCod: filtros.moneda,
    };
    const result = await MWSaldoGet(payload);
    const saldos = result.reduce((acc, item) => {
      const {
        saldoFecha,
        saldoIngresos,
        saldoCantidadIngresos,
        saldoEgresos,
        saldoCantidadEgresos,
        saldoInicial,
        saldoFinal,
      } = item;

      const saldo = {
        id: saldoFecha,
        [titles[0]]: saldoFecha,
        [titles[1]]: saldoInicial,
        [titles[2]]: saldoIngresos,
        [titles[3]]: saldoEgresos,
        [titles[4]]: saldoFinal,
        [titles[5]]: `${saldoCantidadIngresos}`,
        [titles[6]]: `${saldoCantidadEgresos}`,
      };
      return [...acc, saldo];
    }, []);
    setSaldos(saldos);
    setCargando(false);
  },[credentials, filtros.desde, filtros.hasta, filtros.moneda]);

  useEffect(() => {
    if (Object.keys(credentials).length > 0) retrieveSaldos();
  }, [credentials, filtros, retrieveSaldos]);

  useEffect(() => {
    setRoute(Routes[window.location.pathname.split("/")[1]]);
    setRow({ status: false, row: {} });
  }, []);

  return (
    <main>
      <TransitionModal
        titles={titles}
        updateList={retrieveSaldos}
        moneda={filtros.moneda}
      />
      <div style={{display: "flex", alignItems: "center"}}>
        <Filtros
          filtros={filtros}
          setFiltros={setFiltros}
          updateList={retrieveSaldos}
          cargando={cargando}
          isBalance
        />
        <div style={{paddingBlock: "0.5em", height: "4em", display: "flex", alignItems: "end"}}>
          <HeaderButton
              text={"Descargar tabla"}
              handleClick={() => {
                // setBlockModal(true)
                handleExport()
              }}
              data={{ action: "noOpen" }}
          >
              <CloudDownloadIcon/>
          </HeaderButton>
        </div>
      </div>
      <div className="row-grid" id="grid-container">
        {cargando ? (
          <CircularIndeterminate />
        ) : (
          <XGridDemo rows={saldos} titles={titles} />
        )}
      </div>
    </main>
  );
}
